import { useRef, useEffect, EffectCallback } from 'react'
import isEqual from 'lodash/isEqual'

/**
 * A custom hook that does a deeper equality check than regular useEffect.
 * Takes in a callback and an array of dependencies just like useEffect.
 *
 * useEffect renders on every update to it's dependencies, even if those dependencies are simply
 * updated with no values changing. This hook ensures that callbacks are only called when a value
 * specifically changes in it's dependencies.
 *
 * @param callback - A function that will be called whenever the dependencies change
 * @param dependencies - An array of any type of values to be watched for changes
 * @returns { void }
 */

const useDeepCompareMemoize = (val: any) => {
  const ref = useRef()
  if (!isEqual(val, ref.current)) {
    ref.current = val
  }
  return ref.current
}

const useDeepCompareEffect = (
  callback: EffectCallback,
  dependencies: any[]
) => {
  useEffect(callback, useDeepCompareMemoize(dependencies))
}

export default useDeepCompareEffect
